/**
 * Cómo se escriben los números y las fechas del torneo.
 *
 * Vive suelto y no dentro de una pantalla porque la efectividad aparece en
 * cinco lugares distintos —la tarjeta del torneo, la tabla, cada partida, el
 * resumen de carrera— y con signo en todos: en una columna de cifras sueltas
 * un −20 se lee igual que un 20 y significa lo contrario.
 */

/** Con signo siempre, salvo el cero. */
export function conSigno(valor: number): string {
  if (valor === 0) return '0'
  return valor > 0 ? `+${valor}` : String(valor)
}

/** La clase que le pone color: verde arriba de cero, rojo abajo. */
export function signoDe(valor: number): 'mas' | 'menos' | 'cero' {
  return valor > 0 ? 'mas' : valor < 0 ? 'menos' : 'cero'
}

const MESES = [
  'enero',
  'febrero',
  'marzo',
  'abril',
  'mayo',
  'junio',
  'julio',
  'agosto',
  'septiembre',
  'octubre',
  'noviembre',
  'diciembre',
]

/**
 * «14 de marzo de 2026».
 *
 * Se arma a mano en vez de con `Intl` porque la fecha del torneo es un día
 * calendario y no un instante: pasarla por `new Date()` la corre al huso del
 * teléfono, y un torneo del 14 se muestra como el 13 en cualquiera que esté al
 * oeste. Partir el ISO por guiones es lo que garantiza que el día que se ve sea
 * el día que se juega.
 */
export function fechaLarga(iso: string): string {
  const [ano, mes, dia] = iso.slice(0, 10).split('-')
  const nombreMes = MESES[Number(mes) - 1]
  if (!ano || !dia || !nombreMes) return iso
  return `${Number(dia)} de ${nombreMes} de ${ano}`
}

/** «14 mar 2026», para las listas donde no entra la fecha larga. */
export function fechaCorta(iso: string): string {
  const [ano, mes, dia] = iso.slice(0, 10).split('-')
  const nombreMes = MESES[Number(mes) - 1]
  if (!ano || !dia || !nombreMes) return iso
  return `${Number(dia)} ${nombreMes.slice(0, 3)} ${ano}`
}

/** El puesto como se dice: «4º de 22». */
export function puesto(posicion: number): string {
  return `${posicion}º`
}

/** «2 partidas», «1 partida». Es el plural que más se repite en la web. */
export function plural(cantidad: number, singular: string, plural_: string): string {
  return `${cantidad} ${cantidad === 1 ? singular : plural_}`
}

/**
 * Cuántos compiten, dicho en la unidad de la modalidad.
 *
 * En Parejas el torneo cuenta parejas y no personas: «40 jugadores» en un
 * torneo de 40 parejas es la mitad de la gente, y el que lee se pregunta dónde
 * están los otros. En las otras dos modalidades la unidad es la persona.
 */
export function cuantosCompiten(cantidad: number, modalidad: string): string {
  return modalidad === 'parejas'
    ? plural(cantidad, 'pareja', 'parejas')
    : plural(cantidad, 'jugador', 'jugadores')
}
